import React from 'react'
import { FormattedMessage } from 'react-intl'

export const SUCCESS_SCREEN_GREETING = <FormattedMessage id="success_screen.greeting" defaultMessage="ПОЗДРАВЛЯЕМ!" />

export const SUCCESS_SCREEN_MESSAGE = (
    <FormattedMessage id="success_screen.message" defaultMessage="ВЫ ВСТУПИЛИ В КЛАН" />
)

export const WAITING_SCREEN_MESSAGE = (
    <FormattedMessage id="waiting_screen.message" defaultMessage="ВАШЕ ВСТУПЛЕНИЕ В КЛАН ОДОБРЕНО" />
)

export const WAITING_SCREEN_INFO = (
    <FormattedMessage id="waiting_screen.info" defaultMessage="Вступление в клан может занять некоторое время" />
)

export const BUTTON_BACK_TO_HANGAR = (
    <FormattedMessage id="success_screen.button.to_hangar" defaultMessage="Вернуться в Ангар" />
)

export const SUCCESS_SCREEN_AWARD_MESSAGE = (
    <FormattedMessage
        id="success_screen.award_message"
        defaultMessage="Награда за вступление в клан — особый стиль «Клановый повседневный»"
    />
)



// WEBPACK FOOTER //
// ./containers/Landing/components/LandingResult/translations.js